namespace advisorop.domains {
    "use strict";

    export interface IMeetingHubCalendar {
        id?: number;

        calendarId?: string;

        calendarName?: string;

        owner?: string;

        color?: string;

        useWithMeetingHub?: boolean;

        advisorId?: number;
    }
}